/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.4.1 ./public/models/torusknot/torusknot.glb 
*/

import React, { useRef } from "react";
import * as THREE from "three";
import { useGLTF, MeshTransmissionMaterial } from "@react-three/drei";
import { RigidBody } from "@react-three/rapier";
import { useFrame } from "@react-three/fiber";

export default function TorusKnotTube({ ...props }) {
  /**
   * IMPORT MODEL - TORUSKNOT TUBE, BALL
   */
  const { nodes, materials } = useGLTF("/models/torusknot/torusknot.glb ");

  /**
   * ANIMATION
   */
  const torusKnotTube = useRef();

  useFrame((state, delta) => {
    const time = state.clock.getElapsedTime();

    const eulerRotation = new THREE.Euler(time * 0.15, time * 0.2, time * 0.3);
    const quaternionRotation = new THREE.Quaternion();
    quaternionRotation.setFromEuler(eulerRotation);

    torusKnotTube.current.setNextKinematicRotation(quaternionRotation);
  });

  return (
    <group {...props} dispose={null}>
      <RigidBody
        ref={torusKnotTube}
        type="kinematicPosition"
        colliders="trimesh"
      >
        <mesh geometry={nodes["torusknot-tube"].geometry}>
          <MeshTransmissionMaterial backside={true} thickness={2} />
        </mesh>
      </RigidBody>

      <RigidBody colliders="ball">
        <mesh
          geometry={nodes["torusknot-ball"].geometry}
          material={materials["metal-material"]}
          position={[0.001, 1.004, 0]}
        />
      </RigidBody>
    </group>
  );
}

useGLTF.preload("/models/torusknot/torusknot.glb ");
